export const answerIconsIndicatorCss = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  width: "58px",
};

export const leftSideAnswerIndicatorCss = (firstAnswerStatus) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: "28px",
  height: "20px",
  borderRadius: "10px 0 0 10px",
  backgroundColor: firstAnswerStatus ? "#0F8670" : "#DD3636",
});

export const rightSideAnswerIndicatorCss = (secondAnswerStatus) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: "28px",
  height: "20px",
  borderRadius: "0 10px 10px 0",
  backgroundColor: secondAnswerStatus ? "#0F8670" : "#DD3636",
});

export const iconStyles = {
  width: "14px",
};

export const checkIconStyles = [
  {
    path: {
      stroke: "white",
      strokeWidth: "4",
    },
  },
  iconStyles,
];

export const closeIconStyleCss = [
  {
    path: {
      stroke: "white",
      strokeWidth: "5.5",
    },
  },
  iconStyles,
];
